/*jshint esversion: 6 */

/*
   Purpose: Use a jQuery UI dialog to control a modal (as defined in a separate template).
   On smaller (mobile) screens shows the modal full width.
   Works when orientation of mobile changes by resetting the width.
   Typically used for the Christmas CEO messages.
 */
let WidgetModal = function(config){

    const modalElement = document.querySelector(config.selector);

    // Turn off the local storage mechanism by not setting this attribute on the modal.
    config.localStorageKey = modalElement?.getAttribute('data-local-storage-key');

    // jquery ui dialog
    let dialogSettings = {
        autoOpen: false,
        width: Math.min(window.innerWidth, config.maxWidth),
        draggable: false,
        resizable: false,
        modal: true,
        dialogClass: config.dialogClass,
        position: {
            my: "center top",
            at: "center top",
            of: "body"
        },
        title: "",
        show: {
            effect: "blind",
            duration: config.animationDuration
        },
        hide: {
            effect: "blind",
            duration: config.animationDuration
        },
        open: function(){
            document.querySelector('.ui-widget-overlay').addEventListener('click', function(){
                $(config.selector).dialog('close'); // jQuery UI call
            });
        },
        close: function() {
            if (typeof config.localStorageKey !== 'undefined' && config.localStorageKey !== null) {
                localStorage.setItem(config.localStorageKey, "1");
            }
            const xmasVideoIframe = document.getElementById('xmas-video-iframe');
            if (xmasVideoIframe) {
                xmasVideoIframe.remove();
            }
        },
        closeOnEscape: true,
    };

    // Fix problem where the close button icon X does not appear due to loading jQuery after Bootstrap javascripts.
    // https://stackoverflow.com/questions/17367736/jquery-ui-dialog-missing-close-icon
    if (typeof $.fn.bootstrapBtn =='undefined') {
        $.fn.bootstrapBtn = $.fn.button.noConflict();
    }

    $(config.selector).dialog(dialogSettings);

    // button fix for jQuery UI close button icon X problem
    $(config.selector).closest(".ui-dialog")
        .find(".ui-dialog-titlebar-close")
        .empty()
        .addClass("ui-button ui-corner-all ui-widget ui-button-icon-only")
        .attr("title", "Close")
        .append("<span class='ui-button-icon ui-icon ui-icon-closethick'></span>")
        .append("<span class='ui-button-icon-space'> </span>Close");

    if (typeof config.buttonSelector !== 'undefined') {
        document.querySelectorAll(config.buttonSelector).forEach(button => {
            button.addEventListener('click', function() {
                $(config.selector).dialog("open"); // jQuery UI call
            });
        });
    }

    let open = function() {

        if (typeof config.localStorageKey !== 'undefined' && config.localStorageKey !== null) {
            let stateString = localStorage.getItem(config.localStorageKey);
            if(stateString !== null){
                return;
            }
        }

        $(config.selector).dialog("open"); // jQuery UI call
    };

    // Mobile devices change width depending on orientation and this will resize the width accordingly.
    // It is also helpful for testing e.g. in responsive chrome dev tools the dialog will stay full width.
    window.addEventListener('resize', function () {
        if(window.innerWidth <= config.maxWidth) {
            $(config.selector).dialog('option', 'width', window.innerWidth); // jQuery UI call
        }
    });

    return {
        open: open
    };

};

export default WidgetModal;


